import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalkmeContainerComponent } from './walkme-container/walkme-container.component';

@NgModule({
  declarations: [WalkmeContainerComponent],
  imports: [CommonModule],
  exports: [WalkmeContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WalkmeModule {}
